"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localPlayerReducer = exports.initialLocalPlayerState = void 0;
const models_1 = require("@creature-chess/models");
const toolkit_1 = require("@reduxjs/toolkit");
const models_2 = require("@creature-chess/models");
exports.initialLocalPlayerState = {
    xp: 0,
    matchRewards: null,
    opponentId: null,
    opponentIsClone: false,
};
exports.localPlayerReducer = (0, toolkit_1.createReducer)(exports.initialLocalPlayerState, (builder) => {
    builder
        .addCase(models_1.PlayerCommands.playerInfoCommands.playerMatchRewardsEvent, (state, action) => {
        state.matchRewards = action.payload;
    })
        .addCase(models_1.PlayerCommands.playerInfoCommands.updateOpponentCommand, (state, action) => {
        var _a;
        state.opponentId = action.payload.id;
        state.opponentIsClone = (_a = action.payload.isClone) !== null && _a !== void 0 ? _a : false;
    })
        .addCase(models_1.PlayerCommands.playerInfoCommands.updateLevelCommand, (state, action) => {
        state.xp = action.payload.xp;
    })
        .addCase(models_1.GameEvents.gamePhaseStartedEvent, (state, action) => {
        if (action.payload.phase === models_2.GamePhase.PREPARING) {
            state.opponentId = null;
            state.opponentIsClone = false;
        }
    });
});
